import { ApiService, Model } from '@kaiser-software/chassis-core';

export class AddressModel extends Model {
    public id: number;
    public type: string;
    public addresable_id: number;
    public addressable_type: string;
    public label: string;
    public street: string;
    public house_number: string;
    public zip_code: string;
    public city: string;
    public state: string;
    public country: string;
    public email: string;
    public phone: string;
    public notes: string;

    public constructor(data?: Object, _service?: ApiService) {
        super(data, _service);

        this.boot(data);
    }
}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/addresses/models/address.model.ts